import { Component, OnInit, ViewChild, ViewContainerRef, Host  } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, NavigationEnd } from '@angular/router';

import { MatSnackBar } from '@angular/material';
import { AppSnackbarComponent } from './helpers/app-snackbar.component';

import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';

import { AppAuthService } from './auth/auth.service';

import { environment } from './../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [AppAuthService],

})
export class AppComponent {
  title = 'elzeviro';
  public publisher: string;
  public version: string = '2.0.1';

  constructor(
    public authService: AppAuthService,
    private router: Router,
    private snackBar: MatSnackBar,
    private toastyService: ToastyService,
    private toastyConfig: ToastyConfig) {
    this.toastyConfig.theme = 'material';
    this.publisher = environment.publisher;
  }

  onActivate(child) {
    this.title = child.getTitle();
  }

  public operSnackBar(success: boolean, message: string) {

    this.snackBar.openFromComponent(AppSnackbarComponent, {
      duration: 3000,
      extraClasses: [success ? 'snack-bar-success-class' : 'snack-bar-danger-class'],
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      viewContainerRef: null,
      data: message
    }).afterDismissed().subscribe(o => {
      console.log('afterDismissed')
    })
  }

  clearToast(toastId) {
    this.toastyService.clear(toastId);
  }

  addToast(title, msg, cb) {
    var toastOptions: ToastOptions = {
      title: title,
      msg: msg,
      showClose: false,
      timeout: 0,
      theme: 'material',
      onAdd: (toast: ToastData) => {
        cb(toast.id)
      },
      onRemove: function(toast: ToastData) {
      }
    }
    this.toastyService.wait(toastOptions);
  }

  addPopupToast(title, msg, timeout, success, cb) {
    var toastOptions: ToastOptions = {
      title: title,
      msg: msg,
      showClose: false,
      timeout: timeout,
      theme: 'material',
      onAdd: (toast: ToastData) => {
        if(cb) {
          cb(toast.id)
        }
      },
      onRemove: function(toast: ToastData) {
      }
    }
    if(success) {
      this.toastyService.success(toastOptions);
    } else {
      this.toastyService.error(toastOptions);
    }
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts